import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/night.vue')
  },
  {
    path: '/morning',
    name: 'morning',
    component: () => import(/* webpackChunkName: "about" */ '../views/morning.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
